import { Capacitor } from "@capacitor/core";

export const isNative = () => Capacitor.isNativePlatform();

// Seus IDs REAIS do AdMob
export const PROD_IDS = {
  banner:       "ca-app-pub-4517492586963118/2371481264",
  interstitial: "ca-app-pub-4517492586963118/7151058863",
  rewarded:     "", // crie um bloco rewarded real antes de ativar
};

export const USE_TEST_ADS = false;
export const AD_IDS = PROD_IDS;

let admobInitialized = false;
export async function initAdMob() {
  if (!isNative() || admobInitialized) return;
  try {
    const { AdMob } = await import("@capacitor-community/admob");
    await AdMob.initialize({
      requestTrackingAuthorization: false,
      initializeForTesting: USE_TEST_ADS,
    });
    admobInitialized = true;
    console.log("[AdMob] Inicializado");
  } catch (err) {
    console.warn("[AdMob] Erro ao inicializar:", err);
  }
}

let interstitialReady = false;
export async function prepararIntersticial() {
  if (!isNative()) return;
  try {
    const { AdMob } = await import("@capacitor-community/admob");
    await AdMob.prepareInterstitial({
      adId: AD_IDS.interstitial,
      isTesting: USE_TEST_ADS,
    });
    interstitialReady = true;
    console.log("[AdMob] Intersticial pronto");
  } catch (err) {
    console.warn("[AdMob] Erro ao preparar intersticial:", err);
  }
}

export async function mostrarIntersticial() {
  if (!isNative() || !interstitialReady) return;
  try {
    const { AdMob } = await import("@capacitor-community/admob");
    await AdMob.showInterstitial();
    interstitialReady = false;
    prepararIntersticial(); // já prepara o próximo
  } catch (err) {
    console.warn("[AdMob] Erro ao mostrar intersticial:", err);
  }
}

export async function mostrarRewarded(onRecompensa) {
  if (!isNative()) { onRecompensa?.(); return; }
  if (!AD_IDS.rewarded) {
    console.warn("[AdMob] Rewarded sem bloco configurado");
    return;
  }
  try {
    const { AdMob } = await import("@capacitor-community/admob");
    await AdMob.prepareRewardVideoAd({
      adId: AD_IDS.rewarded,
      isTesting: USE_TEST_ADS,
    });
    const result = await AdMob.showRewardVideoAd();
    if (result?.reward) onRecompensa?.(result.reward);
  } catch (err) {
    console.warn("[AdMob] Erro no rewarded:", err);
  }
}
